import ApiService from '@/common/api.service'
import AlertService from '@/common/alert.service'

import { getField, updateField } from 'vuex-map-fields';

/* eslint-disable */
const getDefaultState = () => {
  return {
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
  fetchOrderLogs(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.post('orderlog/getall', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  fetchLoginLogs(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.post('loginLog/getall', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
